<template>
  <div>
    <div class="materials mt-3 ml-3">
      <div class="col-md-12 material-details">
        <div class="material-title">
          {{ material | materialNameShort }}<template v-if="material.bruto"> (bruto persplaat)</template>
        </div>
        <div class="material-width">
          {{ material | materialWidth }}
        </div>
      </div>

      <div class="col-md-13 material-preview">
        <div class="col-md-6 card material-preview-card bg-light" v-if="side1">
          <div class="row no-gutters">
            <div class="col-auto">
              <img v-lazy="side1.image" :alt="side1.label" class="img-fluid image-side" >
            </div>
            <div class="col">
              <div class="card-block p-2">
                <div class="material-label">{{ side1.label }}</div>
                <div class="material-description">{{ side1.description }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 card material-preview-card bg-light" v-if="side2">
          <div class="row no-gutters">
            <div class="col-auto">
              <img v-lazy="side2.image" :alt="side2.label" class="img-fluid image-side" >
            </div>
            <div class="col">
              <div class="card-block p-2">
                <div class="material-label">{{ side2.label }}</div>
                <div class="material-description">{{ side2.description }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 card material-preview-card bg-light" v-if="!side1 && !side2">
          <div class="row no-gutters">
            <div class="col-auto">
              <img v-lazy="product.image" :alt="product.title" class="img-fluid image-side" >
            </div>
            <div class="col">
              <div class="card-block p-2">
                <div class="material-label">{{ product.sku }}</div>
                <div class="material-description">{{ product.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <app-brutoplates v-if="material.bruto" :material="material"></app-brutoplates>
    <app-panels v-else :material="material"></app-panels>
  </div>
</template>

<script>
  import BrutoPlates from "@/components/OrderDetails/BrutoPlates.vue";
  import Panels from '@/components/OrderDetails/Panels.vue'

  export default {
    props: ['material'],
    data() {
      return {}
    },
    components: {
      'app-brutoplates': BrutoPlates,
      'app-panels': Panels
    },
    computed: {
      product() {
        return this.material.product
      },
      side1() {
        return this.material.side1
      },
      side2() {
        return this.material.side2
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
